/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { toast } from 'react-hot-toast';

import { Row, Col } from 'reactstrap';
import { Form } from '@unform/web';
import { MdEdit } from 'react-icons/md';
import CheckboxInput from '~/components/Form/Checkbox';

import api from '~/services/api';
import axios from 'axios';
import { useAuth } from '~/context/AuthContext';
import SaveButton from '~/components/Buttons/SaveButton';
import DownloadButton from '~/components/Buttons/DownloadButton';
import PermissionErrorContainer from '~/components/PermissionErrorContainer';
import { PageTitle } from '~/components/PageTitle';
import { Button } from 'takeat-design-system-ui-kit';
import {
  Container,
  Card,
  Header,
  TablesTable,
  EditButton,
  DeleteAndEditActions,
} from './styles';
import { PrinterModal } from './NewPrinter/PrinterModal';
import NewPrinterPage from './NewPrinter/NewPrinterPage/NewPrinterPage';

function Settings() {
  const { user, updateUser, token } = useAuth();
  const formRef = useRef(null);
  const [printers, setPrinters] = useState([]);
  const [printWeb, setPrintWeb] = useState(user.is_printed_on_web);
  function changePrintWeb() {
    setPrintWeb(!printWeb);
  }

  const getPrinters = useCallback(async () => {
    const response = await api.get('restaurants/printers');
    setPrinters(response.data);
  }, []);

  const [permission, setPermission] = useState();
  const [loadingPage, setLoadingPage] = useState(false);

  const validateUser = useCallback(async () => {
    setLoadingPage(true);
    try {
      const response = await api.get(
        `/restaurants/users/role-permission/${'Configurations'}`
      );
      setLoadingPage(false);
      const { can_read } = response.data.Configurations;

      setPermission(can_read);
    } catch (error) {
      // setPermission(false);
      // if (error?.response?.data?.payload?.user_access === 'pdv') {
      //   window.location.href = '/operation';
      // }
      setLoadingPage(false);
      toast.error('Erro ao solicitar acesso');
    }
  }, []);

  useEffect(() => {
    validateUser();
  }, [validateUser]);

  async function ClickSubmit(data) {
    try {
      let updateProfile = null;

      await api.put('/restaurants/settings', {
        print_complement_category_title: data.print_complement_category_title,
      });

      if (data.is_printed_on_web) {
        updateProfile = {
          is_printed_on_web: data.is_printed_on_web,
          auto_print_orders: false,
          print_bills_on_web: false,
          print_separate_itens: false,
          print_transfer: false,
          print_canceled: false,
          auto_print_delivery: false,
          print_bills_delivery_on_web: false,
          // ifood_auto_accept: false,
          email: user.email,
          print_balcony_default: data.print_balcony_default,
          print_complement_category_title: data.print_complement_category_title,
          print_baskets_in_kds: false,
        };
      } else {
        updateProfile = {
          is_printed_on_web: data.is_printed_on_web,
          auto_print_orders: data.auto_print_orders,
          print_bills_on_web: data.print_bills_on_web,
          print_separate_itens: data.print_separate_itens,
          print_transfer: data.print_transfer,
          print_canceled: data.print_canceled,
          auto_print_delivery: data.auto_print_delivery,
          print_bills_delivery_on_web: data.print_bills_delivery_on_web,
          // ifood_auto_accept: data.ifood_auto_accept,
          email: user.email,
          print_balcony_default: data.print_balcony_default,
          print_complement_category_title: data.print_complement_category_title,
          print_baskets_in_kds: data.print_baskets_in_kds,
        };
      }

      updateUser(updateProfile);
    } catch (err) {
      toast.error('Falha ao altualizar.');
    }
  }

  function downloadDriver() {
    window.open(
      'https://www.mediafire.com/file/6m1rtf4xmqzkisq/Aplicativo_Impress%25C3%25A3o.rar/file'
    );
  }

  const [downloadUrl, setDownloadUrl] = useState(null);
  const [newPrinterModal, setNewPrinterModal] = useState(false);
  const [printerNames, setPrinterNames] = useState(null);
  const [printerNamesLoading, setPrinterNamesLoading] = useState(false);
  const fetchPrintersNames = async () => {
    setPrinterNamesLoading(true);
    try {
      const response = await axios.get(
        'https://backend-pdv.takeat.app/restaurants/printers/names',
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log('response', response.data.printerNames);
      if (response.data.printerNames && response.data.printerNames.length > 0) {
        const printerNamesForSelectInput = response.data.printerNames.map(
          (printer) => ({
            label: printer,
            value: printer,
          })
        );
        setPrinterNames(printerNamesForSelectInput);
      } else {
        toast.error('Nenhum nome de impressora encontrado.');
      }
    } catch (e) {
      toast.error('Erro ao buscar nomes de impressoras.');
      console.log('error downloading printer app:', e);
    } finally {
      setPrinterNamesLoading(false);
    }
  };
  const openNewPrinterModal = async () => {
    setNewPrinterModal(true);
    await fetchPrintersNames();
  };
  function downloadPrinterApp() {
    if (!downloadUrl) {
      toast.error('URL para download do app não disponível.');
      return;
    }
    window.open(downloadUrl);
  }
  useEffect(() => {
    const fetchPrinterApp = async () => {
      try {
        const response = await fetch(
          'https://api.github.com/repos/TakeatGD/takeat-printer-app/releases/latest'
        );
        const data = await response.json();
        const exeAsset = data.assets.find((asset) =>
          asset.name.endsWith('.exe')
        );
        if (exeAsset) {
          setDownloadUrl(exeAsset.browser_download_url);
        }
      } catch (e) {
        console.log('error fetching printer-app url:', e);
      }
    };
    fetchPrinterApp();
  }, []);

  useEffect(() => {
    try {
      getPrinters();
    } catch (err) {
      // console.tron.log(err);
    }
  }, [getPrinters]);

  const [isButtonDisable, setIsButtonDisable] = useState(true);
  const [pixelIdState, setPixelIdState] = useState(user.pixel_id);

  const handleSubmitPixelId = useCallback(async (data) => {
    const updateProfile = { pixel_id: data.pixel_id };
    try {
      updateUser(updateProfile);
      setPixelIdState(data.pixel_id);
    } catch (error) {
      toast.error('Erro ao atualizar perfil!');
      console.log(error.message);
    }
  }, []);

  const [autoPrint, setAutoPrint] = useState(user?.auto_print_orders);
  const [autoPrintDelivery, setAutoPrintDelivery] = useState(
    user?.auto_print_delivery
  );

  function handleChangeAutoPrint() {
    setAutoPrint(!autoPrint);
  }

  function handleChangeAutoPrintDelivery() {
    setAutoPrintDelivery(!autoPrintDelivery);
  }

  if (user?.printer_token && user?.using_new_printer) {
    return <NewPrinterPage user={user} />;
  }

  return !permission ? (
    <PermissionErrorContainer loading={loadingPage} />
  ) : (
    <Container>
      <Header>
        <div>
          <PageTitle>Impressoras</PageTitle>
          <p style={{ fontSize: '14px' }} />
        </div>
      </Header>

      <Card>
        <Form initialData={user} onSubmit={ClickSubmit} ref={formRef}>
          <div>
            <h4>Download do Programa de Impressão da Takeat</h4>
            <p>
              O programa de Impressão da Takeat é uma forma de facilitar a
              impressão dos pedidos, fechamentos de contas e relatórios para
              você! Faça o download do programa clicando no botão abaixo,
              instale o programa, faça login com o mesmo e-mail e senha usados
              para acessar o Dashboard, cadastre sua(s) impressora(s), e
              configure-a(s) do jeito que quiser na parte de
              &quot;Impressoras&quot; aqui mesmo, na página de Configurações.
              Qualquer dúvida entre em contato com nossa equipe!
            </p>
            <Row>
              <Col sm="12" lg="6">
                <DownloadButton onClick={downloadDriver} />
              </Col>
            </Row>
            <h4 style={{ marginTop: 20 }}>Impressão Via Web</h4>
            <p>
              Ao deixar essa opção selecionada, todas as impressões serão feitas
              pelo navegador. Se desmarcada, é necessário ter o programa de
              impressão da Takeat instalado e com sua(s) impressora(s)
              configurada(s) no seu computador.
            </p>
            <Row>
              <Col sm="12" lg="6">
                <CheckboxInput
                  label="Impressão via Web"
                  name="is_printed_on_web"
                  onClick={changePrintWeb}
                />
              </Col>
            </Row>
            <p style={{ marginTop: 20 }}>
              Ao ativar a Impressão de Fechamento de Comanda via Web, as
              comandas serão impressas via web mesmo com o programa da Takeat
              instalado no seu computador.
            </p>

            <Row>
              <Col sm="12" lg="6">
                {printWeb ? (
                  <CheckboxInput
                    label="Impressão de Fechamento de Comanda e Relatórios via Web"
                    name="print_bills_on_web"
                    disabled
                    checked={false}
                  />
                ) : (
                  <CheckboxInput
                    label="Impressão de Fechamento de Comanda e Relatórios via Web"
                    name="print_bills_on_web"
                  />
                )}
              </Col>
            </Row>

            <p style={{ marginTop: 20 }}>
              Ao ativar a Impressão de via de Entrega via Web, as comandas com
              informações de entrega do delivery serão impressas via web mesmo
              com o programa da Takeat instalado no seu computador.
            </p>

            <Row>
              <Col sm="12" lg="6">
                {printWeb ? (
                  <CheckboxInput
                    label="Impressão de via de Entrega via Web"
                    name="print_bills_delivery_on_web"
                    disabled
                    checked={false}
                  />
                ) : (
                  <CheckboxInput
                    label="Impressão de via de Entrega via Web"
                    name="print_bills_delivery_on_web"
                  />
                )}
              </Col>
            </Row>

            <Row>
              <p style={{ marginTop: 20 }}>
                Ao ativar a opção abaixo, permite que seja impresso o título da
                categoria de complemento.
              </p>
              <Col sm="12" lg="6">
                <CheckboxInput
                  label="Imprimir título da categoria de complemento"
                  name="print_complement_category_title"
                  defaultValue={user.print_complement_category_title}
                />
              </Col>
            </Row>

            <h4 style={{ marginTop: 20 }}>Impressão Automática</h4>
            <p>
              Se a impressão for pelo programa de impressão da Takeat, instalado
              no seu computador, é possível que os pedidos sejam aceitos e
              impressos automaticamentes ao serem feitos. Com essa opção
              selecionada, todos os pedidos serão aceitos automaticamente e vão
              direto para a aba &quot;Em Preparo&quot; na área de acompanhar os
              pedidos.
            </p>

            <Row>
              <Col sm="12" lg="6">
                {printWeb ? (
                  <div>
                    <CheckboxInput
                      label="Impressão Automática de Pedidos"
                      name="auto_print_orders"
                      disabled
                      checked={false}
                    />
                    {user?.delivery_info?.is_delivery_allowed && (
                      <CheckboxInput
                        label="Impressão Automática de Pedidos de Delivery"
                        name="auto_print_delivery"
                        disabled
                        checked={false}
                      />
                    )}
                    <CheckboxInput
                      label="Imprimir Itens Separadamente"
                      name="print_separate_itens"
                      disabled
                      checked={false}
                    />
                    <CheckboxInput
                      label="Impressão Automática de Comanda de Balcão"
                      name="print_balcony_default"
                      disabled
                      checked={false}
                    />
                    <CheckboxInput
                      label="Impressão Automática de Itens Cancelados"
                      name="print_canceled"
                      disabled
                      checked={false}
                    />
                  </div>
                ) : (
                  <div>
                    <CheckboxInput
                      label="Impressão Automática de Pedidos"
                      name="auto_print_orders"
                      onClick={handleChangeAutoPrint}
                    />
                    <CheckboxInput
                      label="Impressão Automática de Pedidos Delivery"
                      name="auto_print_delivery"
                      onClick={handleChangeAutoPrintDelivery}
                    />
                    {(autoPrintDelivery || autoPrint) && (
                      <CheckboxInput
                        label="Impressão Automática via KDS"
                        name="print_baskets_in_kds"
                      />
                    )}

                    <CheckboxInput
                      label="Imprimir Itens Separadamente"
                      name="print_separate_itens"
                    />
                    <CheckboxInput
                      label="Impressão Automática de Comanda de Balcão"
                      name="print_balcony_default"
                    />
                    <CheckboxInput
                      label="Impressão Automática de Itens Cancelados"
                      name="print_canceled"
                    />
                  </div>
                )}
              </Col>
            </Row>

            <Row style={{ marginTop: 15 }}>
              <Col>
                <SaveButton type="submit">Salvar</SaveButton>
              </Col>
            </Row>
          </div>
        </Form>
        <div>
          <h4>Impressoras</h4>
        </div>
        <TablesTable borderless>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Host</th>
              <th>Imprime</th>
              <th style={{ width: user.internal ? '120px' : 'auto' }}>
                Imprime todas categorias?
              </th>
              {user.internal && (
                <>
                  <th>Modelo</th>
                  <th style={{ width: '130px' }}>Método de Conexão</th>
                  <th>IP ou Porta</th>
                </>
              )}
              <th style={{ width: user.internal ? '110px' : 'auto' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {printers.map((printer) => (
              <tr>
                <td>{printer.name}</td>
                <td>{printer.host}</td>
                <td>
                  <p>{printer.print_bills_allowed && 'Comandas'}</p>
                  <p>{printer.print_orders_allowed && 'Pedidos'}</p>
                  {/* <p>{printer.print_reports_allowed && 'Relatórios'}</p> */}
                </td>
                <td>{printer.is_category_limited ? 'Não' : 'Sim'}</td>
                {user.internal && (
                  <>
                    <td>{printer.model || '-'}</td>
                    <td>{printer.connection_method || '-'}</td>
                    <td>{printer.ip || '-'}</td>
                  </>
                )}
                <td>
                  <DeleteAndEditActions>
                    <EditButton
                      to={{
                        pathname: '/register/printers/edit',
                        state: {
                          printer,
                        },
                      }}
                    >
                      <div>
                        <MdEdit size={17} />
                        Editar
                      </div>
                    </EditButton>
                  </DeleteAndEditActions>
                </td>
              </tr>
            ))}
          </tbody>
        </TablesTable>
      </Card>
    </Container>
  );
}

export default Settings;
